module.exports = __webpack_public_path__ + "media/images/ogp_top-f40a8a12fe9b3484a81d1c2877af3e74.png";